import { createActions, createState, createReducer } from 'reduxsauce-crud'

const DEEP = { deep: true }

export const ContractsRedux = createActions({
  contractsUpdateRequest: ['id', 'data'],
  contractsUpdateSuccess: [''],
  contractsUpdateFailure: ['data'],
  contractRestoreRequest: ['id'],
  contractRestoreSuccess: [''],
  contractRestoreFailure: ['data'],
}, {
  prefix: 'CONTRACTS_',
  defaultActions: {
    get: true,
    getOne: true,
    remove: true,
  },
})

const { Types, Creators } = ContractsRedux
export const ContractsTypes = Types
export default Creators

export const INITIAL_STATE = createState({}, {
  get: true,
  getOne: true,
  remove: true,
})

const contractsUpdateRequest = state =>
  state.merge({ get: { fetching: true, error: null } }, DEEP)

const contractsUpdateSuccess = state =>
  state.merge({ get: { fetching: false, error: null, results: [] } }, DEEP)

const contractsUpdateFailure = (state, data) =>
  state.merge({ get: { fetching: false, error: data, results: [] } }, DEEP)

const contractRestoreRequest = state =>
  state.merge({ get: { fetching: true, error: null } }, DEEP)

const contractRestoreSuccess = state =>
  state.merge({ get: { fetching: false, error: null, results: [] } }, DEEP)

const contractRestoreFailure = (state, data) =>
  state.merge({ get: { fetching: false, error: data, results: [] } }, DEEP)


export const reducer = createReducer(INITIAL_STATE, {
  [Types.contractsUpdateRequest]: contractsUpdateRequest,
  [Types.contractsUpdateSuccess]: contractsUpdateSuccess,
  [Types.contractsUpdateFailure]: contractsUpdateFailure,
  [Types.contractRestoreRequest]: contractRestoreRequest,
  [Types.contractRestoreSuccess]: contractRestoreSuccess,
  [Types.contractRestoreFailure]: contractRestoreFailure,
}, {
  defaultActions: {
    get: true,
    getOne: true,
    remove: true,
  },
  Types,
})



// WEBPACK FOOTER //
// ./src/Data/Redux/ContractsRedux.js